import { useState } from "react";
import { C } from "../../shared/theme";
import { pageColumn } from "../../shared/layout";
import { BottomNav } from "../../shared/BottomNav";
import { TopBar } from "../../shared/TopBar";
import { HELP } from "../../shared/helpContent";
import { intro } from "../../shared/textStyles";
import { AddButton } from "../../shared/AddButton";
import { useAddRequest } from "../../shared/useAddRequest";
import { itemText, listHas, addToList, editInList, removeFromList, moveInList } from "./compassLists";
import { COMPASS_KINDS } from "./compassKinds";
import { CompassItemEditor } from "./CompassItemEditor";
import { CompassRow, SortableRows } from "./CompassParts";
import { listCard } from "../../shared/ListRow";

// Mindset and Gratitude: one list each, with no categories (Craig, 24 Oct 2026: "Mindset entries should be
// generic and not category-specific"; Gratitude the same, 24 Oct 2026). Today's Reminders chooses from them. Each row
// drags by ⠿ (Craig, 29 Oct 2026).
// `kind` is "mindset" or "gratitude"; setCompass(updater) saves the user's compass.
export function CompassListPage({ kind, compass, setCompass, onNav, addRequested, onAddHandled }) {
  const k = COMPASS_KINDS[kind];
  const list = compass?.[k.field] || [];
  const [editing, setEditing] = useState(null); // null, "new", or an item's place in the list
  useAddRequest(addRequested, onAddHandled, () => setEditing("new"));
  const save = (change) => setCompass(p => ({ ...p, [k.field]: change(p[k.field] || []) }));
  const isNew = editing === "new";

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden", background: C.bg, color: C.text, position: "relative" }}>
      {editing !== null && (
        <CompassItemEditor kind={k} item={isNew ? null : list[editing]}
          isTaken={(text) => listHas(list, text, isNew ? -1 : editing)}
          onSave={(item) => save(l => (isNew ? addToList(l, item) : editInList(l, editing, item)))}
          onDelete={() => save(l => removeFromList(l, editing))}
          onClose={() => setEditing(null)} />
      )}
      <TopBar title={k.title} help={HELP[kind]} />
      <div style={{ flex: 1, overflowY: "auto" }}>
        <div style={{ ...pageColumn, padding: "4px 16px 24px" }}>
          {list.length === 0 ? (
            <div style={{ padding: "12px 4px 0", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 16 }}>
              <p style={intro()}>{k.empty}</p>
              <AddButton onClick={() => setEditing("new")}>{`Add a ${k.one}`}</AddButton>
            </div>
          ) : (
            <>
              <p style={{ ...intro(), margin: "8px 4px 16px" }}>
                {k.intro} Each day you can choose up to three to show in Today's Reminders, on the Today page.
              </p>
              <div style={listCard()}>
                <SortableRows texts={list.map(itemText)} onMove={(from, to) => save(l => moveInList(l, from, to))}>
                  {(i, handle) => <CompassRow text={itemText(list[i])} first={i === 0} editLabel={`Edit ${k.one}`} onEdit={() => setEditing(i)} handle={handle} />}
                </SortableRows>
              </div>
            </>
          )}
        </div>
      </div>
      <BottomNav active={null} onNav={onNav} />
    </div>
  );
}
